// PRICE CHANGE
document.addEventListener('sealsubs:price_update', function(e) {
  console.log('e brate')
  setTimeout(() => {
    updatePriceToBecomeMonthly(e);
  }, 150);
});

var monthlyPriceVar = 0;
var discountOnSecondYear = 0.5;

function updatePriceToBecomeMonthly(e) {
  if (e.detail && e.detail.price !== undefined) {

              const displayedDiscount = discountOnSecondYear * 100; // Calculate the percentage

    let slsPrice = document.querySelector('.sls-selling-plan-group-price .sls-price');
    if (slsPrice) {
        // Check if the discount span already exists
        let existingDiscountSpan = slsPrice.querySelector('.discount');
        if (!existingDiscountSpan) {
            // Create the discount span element only if it doesn't exist
            let discountSpan = document.createElement('span');
            discountSpan.className = 'discount';

            discountSpan.textContent = ` -${displayedDiscount}% 2nd year`;  // Corrected order
      
            // Append the span to the slsPrice element
            slsPrice.appendChild(discountSpan);
        }
    }

    
    
    let updatedPrice = e.detail.price;
    const adjustedPrice = updatedPrice / 100;
    const monthlyPrice = adjustedPrice / 12;  
    monthlyPriceVar = monthlyPrice;
 
    let priceSpan = document.querySelector('.sls-selling-plan-group-price .seal-money'); 
    
    if (priceSpan) {
      // Format the monthly price (which is now already divided by 100 and 12)
      priceSpan.textContent = formatPrice(monthlyPrice) + ' per month'; 
      priceSpan.style.order = '2';
    }

  }

      updatePriceDisplay();

  
}

function formatPrice(priceValue) {
  if (typeof priceValue === 'string' && (priceValue.startsWith('€') || priceValue.startsWith('$'))) {
    return priceValue;
  }
  return '€' + parseFloat(priceValue).toFixed(2); // Example: €7.42
}


document.addEventListener('sealsubs:subscription_widget_created', function(e) {
  setTimeout(() => {
    appendContent();
  }, 150);
});

function appendContent() {
  // Get all elements with the class 'sls-option-container'
  const containers = document.querySelectorAll('.sls-option-container');

  // Check if there are at least two containers
  if (containers.length >= 2) {
    // Target the second container (index 1)
    const secondContainer = containers[1];

    // Check if the content has already been added
    if (!secondContainer.querySelector('.product-item')) { // Check for the presence of a specific element added by the HTML

      // Append the HTML to the second container
      secondContainer.innerHTML += html;

      // Create a style element and append the CSS (only once)
      if (!document.querySelector('#dynamic-styles')) {
        const style = document.createElement('style');
        style.id = 'dynamic-styles'; // Add an ID to avoid duplicates
        style.textContent = css;
        document.head.appendChild(style);
      }
    }
  } else {
    console.error("Not enough 'sls-label-container' elements found.");
  }
}


const html = `
  <div class="seal-custom-content-planetcare">
  
    <div class="product-item">
      <img src="https://cdn.shopify.com/s/files/1/0088/0145/2087/files/image_1_1.png?v=1741698351" alt="Product Image" class="product-image">
  
      <div class="product-details"> 
        <div class="discount-row">
          <span class="discount">-€10.00</span>
          <span class="product-name">PlanetCare 2.0 Microfiber Filter</span>
        </div>
        <div class="product-details-description">
          <div class="product-details-description-item">
            <img src="https://cdn.shopify.com/s/files/1/0902/6682/9067/files/1.png?v=1741702561" alt="Checkmark" class="checkmark-img" >
            FREE shipping
          </div>
        </div>
      </div>
    </div>


   <div class="product-item">
      <img src="https://cdn.shopify.com/s/files/1/0088/0145/2087/files/image_1_1.png?v=1741698351" alt="Product Image" class="product-image">
  
      <div class="product-details"> 
        <div class="discount-row">
          <span class="discount">FREE</span>
          <span class="product-name">13 cartridges</span>
        </div>
        <div class="product-details-description">
          <div class="product-details-description-item"> 
            <img src="https://cdn.shopify.com/s/files/1/0902/6682/9067/files/1.png?v=1741702561" alt="Checkmark" class="checkmark-img" >
            1 cartridge lasts for up to 30 washes
          </div>

          <div class="product-details-description-item">
            <img src="https://cdn.shopify.com/s/files/1/0902/6682/9067/files/1.png?v=1741702561" alt="Checkmark" class="checkmark-img" >
            FREE shipping
          </div>

          <div class="product-details-description-item">
            <img src="https://cdn.shopify.com/s/files/1/0902/6682/9067/files/1.png?v=1741702561" alt="Checkmark" class="checkmark-img" >
            FREE return of used cartridges
          </div>
          
        </div>
      </div>
    </div>



     <div class="product-item">
      <img src="https://cdn.shopify.com/s/files/1/0088/0145/2087/files/image_1_1.png?v=1741698351" alt="Product Image" class="product-image">
  
      <div class="product-details"> 
        <div class="discount-row">
          <span class="product-name">Cartridges Subscription</span>
        </div>
        <div class="product-details-description">
          <div class="product-details-description-item"> 
            <img src="https://cdn.shopify.com/s/files/1/0902/6682/9067/files/1.png?v=1741702561" alt="Checkmark" class="checkmark-img" >
            Get 12 cartridges every year
          </div> 

          <div class="product-details-description-item">
            <img src="https://cdn.shopify.com/s/files/1/0902/6682/9067/files/1.png?v=1741702561" alt="Checkmark" class="checkmark-img" >
            FREE shipping
          </div>

          <div class="product-details-description-item">
            <img src="https://cdn.shopify.com/s/files/1/0902/6682/9067/files/1.png?v=1741702561" alt="Checkmark" class="checkmark-img" >
            FREE return of used cartridges
          </div>
          
        </div>        
      </div>

        <div class="price-discount-and-calculation"> </div>
    
  </div>


`;

const css = `
  /* ... your existing CSS ... */

  .seal-custom-content-planetcare {
    width: 100%;
    margin-top: 18px;
  }

  .product-item {
    display: flex;
    align-items: flex-start; /* Align items to the top */
    margin-bottom: 20px; /* Add spacing between items */
  }

  .price-discount-and-calculation {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;
  }

  .product-image {
    width: 100px; /* Adjust image size to match the image */
    height: auto; /* Maintain aspect ratio */
    margin-right: 15px; /* Add spacing between image and text */
  }

  .product-details {
    flex: 1; /* Allow details to take remaining space */
    position: relative; /* For absolute positioning of AUTO REFILL */
  }

  .discount-row, .free-row, .subscription-row, .price-row {
    display: flex;
    align-items: center;
    margin-bottom: 5px; /* Add spacing between rows */
  }

  .product-details-description {
    display: flex;
    flex-direction: column;
  }

  .product-details-description-item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .discount-year {
    margin-left: auto; /* Push discount to the right */
    color: green;
    font-weight: bold;
  }

  .product-name {
    color: black;
    font-weight: bold;
  }

  .checkmark-img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }

  .discount {
    background-color: #3FB7AB;
    margin-right: 10px;
    color: white;
    padding: 1px 6px;
    border-radius:10px;
    font-weight: bold;
  }
 
  .price {
    text-decoration: line-through;
    color: #888;
    margin-right: 5px;
  }

  .discounted-price {
    color: black;
    font-weight: bold;
  }

  .auto-refill {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #eee;
    color: #333;
    padding: 5px 10px;
    border-radius: 3px;
    font-size: 0.8em;
  }

  .old-vs-new-price {
    display: flex;
    flex-direction: row; 
  }

  .button-product {
    background-color: #eff4f7; 
    padding: 20px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  [id*="variant-update-template"] {
  padding: 10px;
  border-top-left-radius: 10px; 
  border-top-right-radius: 10px;
  background-color: #eff4f7;
}
  
`; 

function updatePriceDisplay() {
  // let updatedPrice = document.querySelector('.sls-selling-plan-group-price .seal-money'); 
  
  // if (updatedPrice) {
    // let priceValue = parseFloat(updatedPrice.textContent.replace('€', '')); 
    // priceValue = monthlyPriceVar;
    // console.log(priceValue)
    let monthlyPrice = monthlyPriceVar;
    let discountedPrice = monthlyPrice * discountOnSecondYear; // Apply 50% discount
  
    const priceDisplay = document.querySelector('.price-discount-and-calculation');
    if (priceDisplay) {
      const displayedDiscount = discountOnSecondYear * 100; // Calculate the percentage
  
      priceDisplay.innerHTML = `
          <span class="discount"> -${displayedDiscount}% 2nd year </span>
          <div class="old-vs-new-price">
              <span class="price">${formatPrice(monthlyPrice)}</span>
              <span class="discounted-price">${formatPrice(discountedPrice)}</span>
          </div>
      `;
    }
  
  // }
}